export const OL_V1 = 'v1' as const;
export const OL_V2 = 'v2' as const;
